<template>
  <div ref="scrollContainer" id="page-panel" class="box grow scrollable">
    <div class="customer-top-nav no-print">
      <span class="title">Integration SAGE Cloud</span>
      <div class="controls">
        <el-button @click="close">{{ $t('buttons.close') }}</el-button>
        <el-button type="primary" @click="save" :loading="saving">{{ $t('common.save') }}</el-button>
      </div>
    </div>

    <el-tabs type="border-card">
      <el-tab-pane label="Configuration">
        <p class="bg-accent-lighter p-10">
          <i class="el-icon-warning-outline"></i>
          Configurez l'endpoint SAGE Cloud, puis lancez la synchronisation manuelle.
        </p>

        <el-form :model="model" label-position="top">
          <el-form-item label="Activer l'integration">
            <el-switch v-model="model.active" />
          </el-form-item>

          <el-form-item label="API Base URL" required>
            <el-input v-model="model.apiBaseUrl" placeholder="https://api.sage.com/v1" />
          </el-form-item>

          <el-row :gutter="20">
            <el-col :lg="8" :md="12" :sm="24" :xs="24">
              <el-form-item label="Path factures">
                <el-input v-model="model.invoicesPath" placeholder="/invoices" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12" :sm="24" :xs="24">
              <el-form-item label="Path paiements">
                <el-input v-model="model.paymentsPath" placeholder="/payments" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12" :sm="24" :xs="24">
              <el-form-item label="Path notes de credit">
                <el-input v-model="model.creditNotesPath" placeholder="/credit-notes" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :lg="6" :md="12" :sm="24" :xs="24">
              <el-form-item label="Fenetre de sync (jours)">
                <el-input-number v-model="model.syncWindowDays" :min="1" :max="3650" style="width:100%" />
              </el-form-item>
            </el-col>
            <el-col :lg="6" :md="12" :sm="24" :xs="24">
              <el-form-item label="Timeout (ms)">
                <el-input-number v-model="model.timeoutMs" :min="1000" :max="120000" :step="1000" style="width:100%" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :lg="12" :md="12" :sm="24" :xs="24">
              <el-form-item label="API Key">
                <el-input v-model="model.apiKey" show-password placeholder="Laisser vide pour conserver la valeur existante" />
                <div class="fs-12 secondary-text" v-if="apiKeyMasked">Actuel: {{ apiKeyMasked }}</div>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12" :sm="24" :xs="24">
              <el-form-item label="Bearer Token">
                <el-input v-model="model.bearerToken" show-password placeholder="Laisser vide pour conserver la valeur existante" />
                <div class="fs-12 secondary-text" v-if="bearerTokenMasked">Actuel: {{ bearerTokenMasked }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Synchronisation">
        <p class="mb-10">Synchroniser manuellement Portaus vers SAGE Cloud.</p>
        <div class="controls-inline">
          <el-button type="primary" @click="syncInvoices" :loading="syncingInvoices">Sync factures</el-button>
          <el-button type="primary" @click="syncPayments" :loading="syncingPayments">Sync paiements</el-button>
          <el-button type="primary" @click="syncCreditNotes" :loading="syncingCreditNotes">Sync notes de credit</el-button>
          <el-button type="success" @click="syncAll" :loading="syncingAll">Sync tout</el-button>
        </div>

        <el-alert
          v-if="lastSyncMessage"
          class="mt-15"
          :title="lastSyncMessage"
          type="success"
          :closable="false"
          show-icon
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SageIntegrationAPI from '@/services/API/sage-integration';

export default {
  name: 'SageIntegrationSettings',
  data () {
    return {
      saving: false,
      syncingInvoices: false,
      syncingPayments: false,
      syncingCreditNotes: false,
      syncingAll: false,
      apiKeyMasked: '',
      bearerTokenMasked: '',
      lastSyncMessage: '',
      model: {
        active: false,
        apiBaseUrl: '',
        apiKey: '',
        bearerToken: '',
        invoicesPath: '/invoices',
        paymentsPath: '/payments',
        creditNotesPath: '/credit-notes',
        syncWindowDays: 30,
        timeoutMs: 30000,
      },
    };
  },
  methods: {
    close () {
      this.$router.go(-1);
    },
    initModel (config) {
      this.model.active = !!config.active;
      this.model.apiBaseUrl = config.apiBaseUrl || '';
      this.model.apiKey = '';
      this.model.bearerToken = '';
      this.model.invoicesPath = config.invoicesPath || '/invoices';
      this.model.paymentsPath = config.paymentsPath || '/payments';
      this.model.creditNotesPath = config.creditNotesPath || '/credit-notes';
      this.model.syncWindowDays = Number(config.syncWindowDays || 30);
      this.model.timeoutMs = Number(config.timeoutMs || 30000);
      this.apiKeyMasked = config.apiKeyMasked || '';
      this.bearerTokenMasked = config.bearerTokenMasked || '';
    },
    async fetchConfig () {
      try {
        const config = await SageIntegrationAPI.fetchConfig();
        this.initModel(config);
      } catch (error) {
        this.$message.error(this.$i18n.t('common.errors.generic'));
      }
    },
    async save () {
      this.saving = true;
      try {
        const payload = { ...this.model };
        const config = await SageIntegrationAPI.updateConfig(payload);
        this.initModel(config);
        this.$message.success('Configuration SAGE sauvegardee.');
      } catch (error) {
        this.$message.error(this.$i18n.t('common.errors.generic'));
      } finally {
        this.saving = false;
      }
    },
    _renderSyncMessage (result) {
      if (result == null) return 'Synchronisation terminee.';
      if (result.invoices || result.payments || result.creditNotes) {
        const invoices = (result.invoices && result.invoices.pushedRows) || 0;
        const payments = (result.payments && result.payments.pushedRows) || 0;
        const creditNotes = (result.creditNotes && result.creditNotes.pushedRows) || 0;
        return `Sync terminee: ${invoices} facture(s), ${payments} paiement(s), ${creditNotes} note(s) de credit.`;
      }
      return `Sync ${result.kind || ''} terminee: ${result.pushedRows || 0} ligne(s) envoyee(s).`;
    },
    async syncInvoices () {
      this.syncingInvoices = true;
      try {
        const result = await SageIntegrationAPI.syncInvoices();
        this.lastSyncMessage = this._renderSyncMessage(result);
        this.$message.success('Synchronisation factures terminee.');
      } catch (error) {
        this.$message.error('Erreur de synchronisation des factures.');
      } finally {
        this.syncingInvoices = false;
      }
    },
    async syncPayments () {
      this.syncingPayments = true;
      try {
        const result = await SageIntegrationAPI.syncPayments();
        this.lastSyncMessage = this._renderSyncMessage(result);
        this.$message.success('Synchronisation paiements terminee.');
      } catch (error) {
        this.$message.error('Erreur de synchronisation des paiements.');
      } finally {
        this.syncingPayments = false;
      }
    },
    async syncCreditNotes () {
      this.syncingCreditNotes = true;
      try {
        const result = await SageIntegrationAPI.syncCreditNotes();
        this.lastSyncMessage = this._renderSyncMessage(result);
        this.$message.success('Synchronisation notes de credit terminee.');
      } catch (error) {
        this.$message.error('Erreur de synchronisation des notes de credit.');
      } finally {
        this.syncingCreditNotes = false;
      }
    },
    async syncAll () {
      this.syncingAll = true;
      try {
        const result = await SageIntegrationAPI.syncAll();
        this.lastSyncMessage = this._renderSyncMessage(result);
        this.$message.success('Synchronisation complete terminee.');
      } catch (error) {
        this.$message.error('Erreur de synchronisation complete.');
      } finally {
        this.syncingAll = false;
      }
    },
  },
  created () {
    this.fetchConfig();
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.8em;
  font-weight: bold;
  margin-right: 20px;
  position: relative;
  float: left;
}
.customer-top-nav {
  height: 50px;
}
.controls {
  position: relative;
  float: right;

  button {
    margin-left: 20px;
  }
}
.controls-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
